<!--主表关联的表单的详情，不要跟正常表单详情混用-->
<template>
    <div class="busi-modelDetail-pop">
        <!-- <el-card class="box-card model-top" shadow="always"> -->
        <div class="model-top">
            <div>
                <div>
                    <span><font size="5" >{{formInfo.modelName}}</font></span>
                </div>
            </div>
            <div  class="btns">
                <div class="text-desc desc-content2">
                    <el-row v-if="!isView" style="margin-bottom: 20px">
                        <!-- <div v-if="isShowSaveBtn">
                            <el-button v-if="formBtnAuth && formBtnAuth.isShowEdit && currentRowData.isCanEdit" type="primary"  icon="el-icon-edit-outline" @click="handleModelComplete">保存数据</el-button>
                            <el-button v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " type="success"  icon="el-icon-view"   @click="handleView">审批详情</el-button>
                            <el-button v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!==''&& isShowDown" type="success"  icon="el-icon-download"  @click="exportExcelData">导出数据</el-button>
                            <el-button v-if="formBtnAuth && formBtnAuth.isShowDelete && currentRowData.isCanDelete" type="danger"  icon="el-icon-delete"  @click="handleModelFormDelete">删除</el-button>
                            <el-button v-if="!isShowSaveBtn && isShowForm" type="primary" icon="el-icon-back" @click="switchAddFormData()">返回数据列表</el-button>
                        </div> -->
                        <!-- <div v-if="isAddForm" > -->
                        <div v-if="approvalStatus == 10 || approvalStatus == 13 || (ifShowBtn && ((this.parentFormData&&!this.parentFormData[0].values.hasOwnProperty('id')) || isAddForm))" > 
                            <!--前段保存逻辑-->
                            <el-button type="primary" icon="el-icon-edit-outline"  @click="handleModelComplete">确定</el-button>
                            <el-button type="primary"  icon="el-icon-back" @click="cancelClick()">取消</el-button>
                        </div>
                    </el-row>
                </div>
            </div>
        <!-- </el-card> -->
        </div> 
        <div class="model-content">
            <div class="content-left">
                <div v-for="(form, index) in forms" :key="form.id" :name="form.id">
                <!-- <el-card class="box-card" shadow="always"> -->
                    <!-- <el-collapse  style="height:100%;overflow-y:auto;"  v-if="isShowForm" v-model="collapseActiveName" accordion>
                        <el-collapse-item class="collapseItem" v-for="(form, index) in forms" :key="form.id" :name="form.id"> -->
                            <template slot="title">
                                <div class='el-collapse-title'>
                                    <span></span>
                                    <div class="btns" v-if="!hideAllBtn">
                                        <!-- <el-popover
                                          placement="bottom"
                                          trigger="click">
                                            <el-image
                                                :key="imageKey"
                                                 style="width: 100px; height: 100px"
                                                 :src="qrUrl"
                                                 fit="fill"></el-image>
                                          <el-button slot="reference" size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''" icon="iconfont icon-other-ico" @click.stop="showQR(form)">{{qrTit}}</el-button>
                                        </el-popover>
                                        <el-button size="mini" v-if="isAddForm || isShowCopyHis" icon="el-icon-document-copy" @click.stop="handleSelectFromHis(index,form)">复制数据</el-button>
                                        <el-button size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''" icon="el-icon-download" @click.stop="exportExcelData(index)">导出</el-button>
                                        <el-button size="mini" v-if="(isAddForm&&isShowStartApprovalBtn) || (!isView&&!(currentRowData!=null&&currentRowData.hasOwnProperty('approvalInstanceId')&&currentRowData.approvalInstanceId!=''&& currentRowData.isCanEdit))" icon="el-icon-printer" @click.stop="handleStartApproval(index)">发起审批</el-button> -->
                                        <el-button size="mini" icon="el-icon-printer" @click.stop="handlePrint(index)">打印</el-button>
                                        <!-- <el-button size="mini" v-if="isViewSubFormViewBtn" icon="el-icon-monitor" @click.stop="handleSubFormView(index)">切换子表单显示</el-button>
                                        <el-button v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " size="mini" icon="el-icon-printer" @click.stop="handlePrintApprove(index)">审批流打印</el-button> -->
                                    </div>
                                    <!-- <div class="btns" v-if="hideAllBtn">
                                        <el-button size="mini" v-if="showDiagram && processInstanceId!='' "  title='流程图' circle icon="el-icon-picture-outline" @click.stop="handelShowDiagram(formData[index])"></el-button>
                                    </div> -->
                                </div>
                            </template>
                            <!-- <ul> -->
                            <el-form :model="formData[index].values" :key="loadTimerField" :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                                <!-- 模式3  -->
                                <template v-for="(field,index2) in form.fieldsList" > 
                                    <template v-if="isShowNormalField(field,index,formData[index])">
                                        <FieldItem
                                            :key="field.fieldId"
                                            :findex="index2"
                                            :ref="'fieldItemChild'+index2"
                                            :formId="form.id"
                                            :formConfig="form" 
                                            :field="field"
                                            :isRead="field.isRead || isRead"
                                            :isView="field.isView"
                                            :formData="formData[index].values"
                                            :colSpan="form.colSpan"
                                            :taskInstance="taskInstance"
                                            :processModelFormsObj="processModelFormsObj"
                                            :processInstance="processInstance"
                                            :fieldsList="form.fieldsList"
                                            :linkFieldCache="linkFieldCache"
                                            @loadLinkData="loadLinkData"
                                            @refreshViewField="refreshViewField"
                                            @asynMainFormData="asynMainFormData"
                                            v-if="(field.isView&&taskInstance) || !field.formFieldAuth || field.formFieldAuth ==='1'"
                                            
                                        />
                                    </template>
                                </template>
                                <div class="render-form-item" style="width: 100%; float: left;" v-if="(formData[index].values['subFormViewMode']!==0 && formData[index].ext1===1) || (formData[index].values['subFormViewMode'] && (formData[index].values['subFormViewMode'] > 0))">
                                    <el-row>
                                        <el-form-item label="" style="width: 100%;">
                                            <el-tabs :key="loadTimerField" v-model="defaultViewOrder" > 
                                                <template v-for="(field,index2) in form.fieldsList" > 
                                                    <template v-if="field.type === 'subform' && (field.ext2 !== '1' || formData[index].values[field.id + '-casDefautShow'])" > 
                                                        <el-tab-pane   :key="index2" :label="getSubformName(formData[index].values,field)" :name="index2+''">
                                                            <FieldItem
                                                                :key="field.fieldId"
                                                                :findex="index2"
                                                                :ref="'fieldItemChild'+index2"
                                                                :formId="form.id" 
                                                                :formConfig="form" 
                                                                :field="field"
                                                                :isRead="field.isRead || isRead"
                                                                :isView="field.isView"
                                                                :formData="formData[index].values"
                                                                :colSpan="form.colSpan"
                                                                :taskInstance="taskInstance"
                                                                :processModelFormsObj="processModelFormsObj"
                                                                :processInstance="processInstance"
                                                                :fieldsList="form.fieldsList"
                                                                :subFormViewMode="1"
                                                                :linkFieldCache="linkFieldCache"
                                                                @loadLinkData="loadLinkData"
                                                                @refreshViewField="refreshViewField"
                                                                @asynMainFormData="asynMainFormData"
                                                                v-if="(field.isView&&taskInstance) || !field.formFieldAuth || field.formFieldAuth ==='1'"
                                                            />
                                                        </el-tab-pane>
                                                    </template>
                                                </template>
                                            </el-tabs> 
                                        </el-form-item>
                                    </el-row>
                                </div>
                                <!-- 关联的其他表单数据 -->
                                <!-- <div class="render-form-item" style="width: 100%; float: left;">
                                <el-row>
                                    <el-form-item label="关联表单" style="width: 100%;">
                                    <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick" v-model="relateFormTabName" > 
                                        <template v-for="(model, index3) in relateModelList" > 
                                            <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id">
                                                <RelateFormList
                                                    :ref="'relateModelList' + model.id"
                                                    :key="loadTimerRelate"
                                                    :selectedModel="model"
                                                />
                                            </el-tab-pane>
                                        </template>
                                    </el-tabs> 
                                    </el-form-item>
                                </el-row>
                                </div> -->
                            </el-form>
                        </div>
                            <!-- </ul> -->
                        <!-- </el-collapse-item>
                    </el-collapse> -->
                <!-- </el-card> -->
            </div>
        </div>
        <el-dialog
            title="表单打印确认页"
            append-to-body
            top="4vh"
            :fullscreen=true
            :visible.sync="isShowPrintUtil">
            <PrintUtil :key="loadTimer" ref="printUtil" :formInfo="printForm"  />
        </el-dialog>
        <el-dialog
            title="审批打印确认页"
            append-to-body
            top="4vh"
            :fullscreen=true
            :visible.sync="isShowApproval">
            <PrintUtilApprove :key="loadTimer" ref="printUtilApprove" :formInfo="printForm"  :isShowApproval="true" />
        </el-dialog>

        <el-dialog
            title="审批模板选择页"
            append-to-body
            top="4vh"
            :fullscreen=true
            :visible.sync="isShowApprovalTemplatePop">
            <ApprovalTemplate :key="loadTimer" ref="approvalTemplate"
                :formInfo="approvalForm"
                :startApproval="true"
                :selectedTemplate="selectedTemplate"
                :isReturnToNav="isReturnToNav"
                @handleNavPage="handleNavPage"/>
        </el-dialog>
        <!-- 显示图标 -->
        <el-dialog
            title="流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDiagram
              ref="diagrams"
              :processInstance="instances"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
            />
        </el-dialog>
        <el-dialog
            title="表单数据选择"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowDataCopyDialog">
            <TableDataPop
                ref="tableDataPop"
                :key="loadTimer"
                :modelId="currentModelId"
                @reloadFormData="reSetProcessFormData"
                >
            </TableDataPop>
        </el-dialog>
        <FieldValidation  ref="fieldValidation"/>
    </div>
</template>

<script>
    import { isEmpty, clone } from 'lodash';
    import { API_EXPORT_MODEL_TITLE_FORM_EXCEL } from '@/common/constants';
    import { getModelFormInstanceById, getModelListByMainFormId, getSerialNumber, getProcessInstancesDetail, getAllUserTask, getArchiveTemplateTreeList, getModelFormInstanceQR, getCrossFieldData } from '@/data-model';
    import PrintUtil from '@/components/PrintUtil';
    import PrintUtilApprove from '@/components/PrintUtil/PrintUtilApprove';
    import ApprovalTemplate from '@/pages/process/ProcessTemplate/ApprovalTemplate.vue';
    import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
    import TableDataPop from '@/components/TableDataPop';
    import FieldValidation from '@/components/Formula/FieldValidation.vue';
    import mixinsNav from '@/mixins/mixins-nav';
    import { getUUID } from '@/utils/grocer';
    export default {
        components: {
            RelateFormList,
            TableDataPop,
            PrintUtil,
            PrintUtilApprove,
            ApprovalTemplate,
            FieldValidation
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                relateFormTabName: '',
                loadTimerRelate: '',
                relateModelList: [], // 关联的表单
                defaultViewOrder: null,
                selectedTemplate: [],
                currentModelId: '',
                formIndex: 0, // 多表单时，用于重置表单数据
                isShowDataCopyDialog: false,
                isShowDiagram: false,
                instances: {},
                taskList: [],
                archiveTemplateTreeList: [],
                isAddForm: false,
                loadTimer: '',
                loadTimerField: '',
                isShowPrintUtil: false,
                isShowPrintForm: false,
                isShowApproval: false,
                isDetailShowForm: this.isShowForm,
                collapseActiveName: '',
                formData: [],
                modelName: '',
                isShowStartApprovalBtn: false, // 发起审批按钮
                isShowSaveBtn: false,
                formBtnAuth: {},
                currentRowData: {id: '', approvalInstanceId: ''},
                isShowDown: false,
                printForm: {},
                isShowApprovalTemplatePop: false,
                approvalForm: {},
                id: '',
                qrUrl: '',
                qrTit: '生成二维码',
                imageKey: '',
                isViewSubFormViewBtn: false,
                linkFieldCache: new Map()
            };
        },
        props: {
            formInfo: {
                type: Object
            },
            processInstanceId: {
                type: String,
                default: ''
            },
            isShowCopyHis: {
                type: Boolean,
                default: false
            },
            isShowForm: {
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isView: {
                type: Boolean,
                default: false
            },
            showDiagram: {// 显示流程图
                type: Boolean,
                default: false
            },
            hideAllBtn: {
                type: Boolean,
                default: false
            },
            isReturnToNav: {// 为发起审批成功后，判断来自于新交互模式还是旧模式，默认旧模式
                type: Boolean,
                default: false
            },
            taskInstance: {
                type: Object
            },
            processInstance: {
                type: Object
            },
            processModelFormsObj: {
                type: Array
            },
            hideRetListBtn: {// 隐藏返回列表按钮
                type: Boolean,
                default: false
            },
            parentFormInfo: {
                type: Object
            },
            parentFormData: {
                type: Array,
                default: []
            },
            ifShowBtn: {
                type: Boolean,
                default: true
            },
            approvalStatus: {
                type: Number
            }
        },
        mounted () {
            this.$nextTick(() => {
                let formInfo = this.formInfo.formObj.structure[0];
                if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                    this.loadTimerField = new Date().getTime();
                    let initUserArr = [];
                    for (var i = 0; i < formInfo.fieldsList.length; i++) {
                        let tempField = formInfo.fieldsList[i];
                        let tempRefName = 'fieldItemChild' + i;
                        if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                            setTimeout(() => {
                                // 设置下拉字段级联默认显示数据
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    this.$refs[tempRefName][0].initDefaultCasData();
                                }
                            }, 0);
                        }
                        if (!this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
                            this.defaultViewOrder = i + '';
                            this.isViewSubFormViewBtn = true;// 显示子表单模式切换按钮
                        }
                        if (tempField.type === 'user') {
                            initUserArr.push(tempRefName);
                        }
                    }
                    for (var j = 0; j < initUserArr.length; j++) { // 针对人员级联初始化
                        let tempRefName = initUserArr[j];
                        setTimeout(async () => {
                            // 设置下拉字段级联默认显示数据
                            if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                            }
                        }, 0);
                    }
                }
            });
        },
        computed: {
            forms () {
                if (isEmpty(this.formInfo.formObj)) {
                    return [];
                } else {
                    this.formInfo.formObj.structure[0].fieldsList.forEach(element => {
                        // 处理权限字段
                        // let ext2 = element.options.ext2;
                        if (element.options && element.options.ext2) {
                            let curObj = JSON.parse(element.options.ext2);
                            element.formFieldAuth = curObj.formFieldAuth;
                            element.approveFieldAuth = curObj.approveFieldAuth;
                        }
                        if (element.type === 'link' && element.options.config && element.options.config.form && this.parentFormInfo && element.options.config.form.formId === this.parentFormInfo.formId) { // 过滤主表字段显示，免得干扰
                            element.isView = false;
                        }
                    });
                    return this.formInfo.formObj.structure;
                }
            },
            sidebarOpened () {
                return this.appState.sidebar.opened;
            }
        },
        created () {
            // console.log(this.approvalStatus);
        },
        methods: {
            async _initData () {
                // await this.forms.forEach(async element => {
                for (let idx = 0; idx < this.forms.length; idx++) {
                    let element = this.forms[idx];
                    let fieldsList = element.fieldsList;
                    let values = {};
                    let attributes = {};

                    let linkFieldIdList = [];
                    for (let index = 0, len = fieldsList.length; index < len; index++) {
                        let ele = clone(fieldsList[index]);
                        values[ele.id] = '';
                        attributes[ele.id] = ele.type;
                        // 将主表单带过来的关联字段值赋值
                        // console.log(this.currentRowData);
                        if (this.currentRowData) {
                            if (ele.type === 'link') {
                                if (!isEmpty(this.currentRowData[ele.id + '-link'])) {
                                    linkFieldIdList.push(ele.id);
                                    values[ele.id] = this.currentRowData[ele.id];
                                    values[ele.id + '-link'] = this.currentRowData[ele.id + '-link'];
                                    values[ele.id + '-view'] = this.currentRowData[ele.id + '-view'];
                                }
                            }
                        }
                        // 处理权限字段
                        let ext2 = ele.options.ext2;
                        if (ext2) {
                            let curObj = JSON.parse(ext2);
                            ele.formFieldAuth = curObj.formFieldAuth;
                            ele.approveFieldAuth = curObj.approveFieldAuth;
                        }
                    }
                    if (this.parentFormInfo.formId === '5b18af83492a41d0a6d23f546150d4ab' && this.formInfo.formId === '498dfb0489764b34a889aa9773cee141') { // 中泽定制化需求，绩效回显值
                        // console.log(this.formInfo);
                        // console.log(this.formData[0]);
                        values['90afb9bab5ef4ea6bec783f7cb65c5c2'] = this.parentFormData[0].values['c4c8dd22a5c645d89df2d3b257e3bd26'];// 市场及业务
                        values['769572dbd6d841b49967fe7556946509'] = this.parentFormData[0].values['7fc386a8d5284b4b8ff8b11b9274445a'];// 市场
                    }
                    this.collapseActiveName = element.id;
                    this.formData.push({
                        formId: element.id,
                        values: values,
                        attributes: attributes,
                        colSpan: element.colSpan ? element.colSpan : 1,
                        ext1: element.ext1 ? Number(element.ext1) : 0
                    });
                    for (let index = 0, len = fieldsList.length; index < len; index++) { // 20230927 edit byhezhen 将主表单带过来的级联字段值赋值
                        let ele = clone(fieldsList[index]);
                        if (this.currentRowData && ele.options.synLinkField && ele.options.synLinkFormFieldId) {
                            this.updSynLinkFieldData(ele, ele, this.currentRowData);
                        }
                    }
                    this.$emit('setIsShowForm', true);
                    // 处理关联字段的关联映射显示
                    if (linkFieldIdList.length > 0) {
                        for (let k = 0; k < linkFieldIdList.length; k++) {
                            let linkFieldId = linkFieldIdList[k];
                            let linkDataId = this.formData[0].values[linkFieldId + '-link'];
                            if (linkDataId) {
                                let linkDataInfo = await getModelFormInstanceById(linkDataId);
                                if (linkDataInfo) {
                                    let allFormFieldList = linkDataInfo.formObj.structure[0].fieldsList;
                                    let linkDataValue = JSON.parse(linkDataInfo.formObj.instance);
                                    let sourceData = linkDataValue.values;
                                    await this.asynMainFormData(sourceData, allFormFieldList, linkFieldId, 0);
                                }
                            }
                        }
                    }
                }
                // });
            },
            handlePrint (index) {
                this.loadTimer = new Date().getTime();
                this.printForm = this.formData[index];
                this.printForm.fieldsList = this.forms[index].fieldsList;
                this.printForm.formName = this.forms[index].formName;
                this.printForm.printTemplate = this.forms[index].printTemplate;
                if (!isEmpty(this.printForm.printTemplate)) {
                    this.printForm.approvalRecordList = this.parentFormInfo.formObj.approvalRecordList;
                    this.printForm.applyUserName = this.formInfo.formObj.applyUserName;
                    this.printForm.applyUserDept = this.formInfo.formObj.applyUserDept;
                    this.printForm.applyUserCreated = this.formInfo.formObj.applyUserCreated;
                    this.printForm.approvalStatus = this.formInfo.formObj.approvalStatus;
                }
                this.dealPrintStr();
                this.isShowPrintUtil = true;
                // this.loadTimer = new Date().getTime();
                // this.printForm = this.formData[index];
                // this.printForm.fieldsList = this.forms[index].fieldsList;
                // this.printForm.formName = this.forms[index].formName;
                // this.isShowPrintUtil = true;
            },
            // 打印模板拼装
            dealPrintStr () {
                if (!isEmpty(this.printForm.printTemplate)) {
                    // 1、子表单占位符处理
                    this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('\r', '').replaceAll('\n', '');
                    // console.log(this.printForm.values);
                    // 获取打印模板中的子表单字段
                    // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                    let elementReg = /(?<={).*?(?=(}|$))/ig;
                    let elements = this.printForm.printTemplate.match(elementReg);
                    let fieldsList = this.printForm.fieldsList;
                    let subElements = [];
                    elements.forEach(item => {
                        for (let index = 0, len = fieldsList.length; index < len; index++) {
                            let fieldObj = fieldsList[index];
                            if (fieldObj.id === item) {
                                let type = fieldObj.type;
                                if (type === 'subform') {
                                    subElements.push(fieldObj);
                                }
                                break;
                            }
                        }
                    });
                    // 子表单字段数据替换、拼接
                    if (subElements.length > 0) {
                        let sourceData = this.printForm.values;
                        // 提取以@Sub开头,以Sub@结尾的中间部分字符串的正则表达式
                        let subFormStrReg = /(?<=@Sub).*?(?=(Sub@|$))/ig;
                        let subFormStrArr = this.printForm.printTemplate.match(subFormStrReg); // 子表单打印模板字符串list
                        for (let i = 0; i < subElements.length; i++) {
                            let subFormField = subElements[i];
                            // 替换子表单名
                            this.printForm.printTemplate = this.printForm.printTemplate.replace('{' + subFormField.id + '}', subFormField.name);
                            // 子表单打印模板
                            // <tr height="60px"><td>{11fd5298335a4cd18b125b689a99f552}</td><td>{a79bf19398024a2b985e7e452829eb7b}</td><td>{435c5c6efd684ca08eaa9d3910a0070f}</td><td>{4d3d281931bc40f8a14523ece5946723}人民币(大写):{d2557de3cd724c4097bfcca37a256510}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td></tr>
                            let subFormTr = clone(subFormStrArr[i]);
                            // 子表单打印模板中的字段占位符
                            let subFormElements = subFormTr.match(elementReg);
                            // console.log(subFormTr);
                            // 子表单数据list
                            let subFormData = sourceData[subFormField.id];
                            // console.log(subFormData);

                            // 替换后的子表单打印模板数据
                            let subFormDataPrint = [];
                            if (subFormData && subFormData.length > 0) {
                                subFormData.forEach(subFormDataItemStr => {
                                    let subFormTrItem = clone(subFormTr);
                                    let subFieldsList = subFormField.options.fieldList;// 子表单的所有字段
                                    subFormElements.forEach(item => {
                                        let sourceValue = ''; // 从源数据中拉出来的字段值
                                        let sourceContent = '{' + item + '}'; // 占位符
                                        for (let index = 0, len = subFieldsList.length; index < len; index++) {
                                            let fieldObj = subFieldsList[index];
                                            if (fieldObj.id === item) {
                                                let type = fieldObj.type;
                                                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                                    // -tree
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-tree'];
                                                } else if (type === 'user') {
                                                    // -user
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-user'];
                                                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                                    // -view
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                                    sourceValue = subFormDataItemStr[fieldObj.id];
                                                } else if (type === 'link') {
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                                }
                                                break;
                                            }
                                        }
                                        if (sourceValue === undefined) {
                                            sourceValue = '';
                                        }
                                        subFormTrItem = subFormTrItem.replaceAll(sourceContent, sourceValue);
                                    });
                                    subFormDataPrint.push(subFormTrItem);
                                });
                            }
                            // 替换后的最终的子表单数据
                            let subFormDataPrintStr = '';
                            for (let index = 0; index < subFormDataPrint.length; index++) {
                                subFormDataPrintStr = subFormDataPrintStr + subFormDataPrint[index];
                            }
                            // 替换到总打印模板里
                            this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('@Sub' + subFormTr + 'Sub@', subFormDataPrintStr);
                            // console.log(this.printForm.printTemplate);
                        }
                    }

                    // 2、表单字段占位符替换处理
                    // console.log(this.printForm.values);
                    // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                    // let elementReg = /(?<={).*?(?=(}|$))/ig;
                    // let elements = this.printForm.printTemplate.match(elementReg);
                    // console.log(elements);
                    if (!isEmpty(elements)) {
                        let sourceData = this.printForm.values;
                        let fieldsList = this.printForm.fieldsList;
                        elements.forEach(item => {
                            let sourceValue = ''; // 从源数据中拉出来的字段值
                            let sourceContent = '{' + item + '}'; // 占位符
                            for (let index = 0, len = fieldsList.length; index < len; index++) {
                                let fieldObj = fieldsList[index];
                                if (fieldObj.id === item) {
                                    let type = fieldObj.type;
                                    if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                        // -tree
                                        sourceValue = sourceData[fieldObj.id + '-tree'];
                                    } else if (type === 'user') {
                                        // -user
                                        sourceValue = sourceData[fieldObj.id + '-user'];
                                    } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                        // -view
                                        sourceValue = sourceData[fieldObj.id + '-view'];
                                    } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                        sourceValue = sourceData[fieldObj.id];
                                    } else if (type === 'link') {
                                        sourceValue = sourceData[fieldObj.id + '-view'];
                                    } else if (type === 'subform') {
                                        sourceValue = sourceData[fieldObj.id];
                                    }
                                    break;
                                }
                            }
                            if (sourceValue === undefined) {
                                sourceValue = '';
                            }
                            this.printForm.printTemplate = this.printForm.printTemplate.replaceAll(sourceContent, sourceValue);
                        });
                    }
                }
            },
            handlePrintApprove (index) {
                this.loadTimer = new Date().getTime();
                this.printForm = this.formData[index];
                this.printForm.fieldsList = this.forms[index].fieldsList;
                this.printForm.formName = this.forms[index].formName;
                this.printForm.approvalRecordList = this.formInfo.formObj.approvalRecordList;
                this.printForm.applyUserName = this.formInfo.formObj.applyUserName;
                this.printForm.applyUserDept = this.formInfo.formObj.applyUserDept;
                this.printForm.applyUserCreated = this.formInfo.formObj.applyUserCreated;
                this.printForm.approvalStatus = this.formInfo.formObj.approvalStatus;
                this.isShowApproval = true;
            },
            handleStartApproval (index) {
                this.loadTimer = new Date().getTime();
                this.approvalForm = this.formData[index];
                if (this.currentRowData) {
                    this.approvalForm.dataId = this.currentRowData.id;
                } else {
                    this.approvalForm.dataId = '';
                }
                this.isShowApprovalTemplatePop = true;
            },
            /** 自定义表单的配置信息，动态生产表单双向绑定所需的数据结构 */
            async _initFormData () {
                let objModelFormData = await this._getModelFormData();
                this.formData = [];
                this.$emit('setIsShowForm', false);
                this.isShowSaveBtn = false;
                if (objModelFormData) {
                    this.collapseActiveName = objModelFormData.formId;
                    let attributes = this.getAttributes(this.formInfo.formObj.structure);// 初始化数据字段结构
                    objModelFormData.attributes = attributes;
                    //= =========解决新增多选组件，历史数据无法使用该组件的问题begin===========
                    let values = clone(objModelFormData.values);
                    for (var prop in attributes) { // 遍历map
                        if (attributes.hasOwnProperty(prop)) {
                            if (attributes[prop] === 'category' || attributes[prop] === 'serialNumber' || attributes[prop] === 'subform') {
                                if (!values.hasOwnProperty(prop)) {
                                    values[prop] = '';
                                }
                            }
                            if (attributes[prop] === 'subform' && values[prop] && values[prop].length > 0) {
                                values[prop].forEach(v => {
                                    if (!v.subId) {
                                        v.subId = getUUID(8, 16);
                                    }
                                });
                            }
                        }
                    }
                    objModelFormData.values = values;
                    //= =========解决新增多选组件，历史数据无法使用该组件的问题end===============
                    this.formData.push(objModelFormData);
                    this.isShowSaveBtn = true;
                    this.$emit('setIsShowForm', true);
                } else {
                    await this._initData();
                }
            },
            async loadFormData (formInfo, formBtnAuth, row, isShowDown) {
                // console.log(formInfo);
                if (row) {
                    this.id = row.id;
                    this.currentRowData = row;
                }
                this.formInfo = formInfo;
                this.isShowStartApprovalBtn = this.formInfo.formObj.canStartApproval;
                this.formBtnAuth = formBtnAuth;
                await this._initFormData();
                if (row === undefined && !this.isRead) {
                    this.currentRowData = {id: '', approvalInstanceId: ''};
                    this.isAddForm = true;
                } else {
                    if (this.id && this.id.length === 16) {
                        this.isAddForm = true;
                    } else if (row.isCanEdit || row.isCanDelete) {
                        this.isAddForm = true;
                    }
                    // this.currentRowData = row;
                }
                this.isShowSaveBtn = true;
                this.isShowDown = isShowDown;

                // TODO
                this.loadTimerRelate = new Date().getTime();
                this.getModelListByMainFormId();
            },
            getAttributes (source) {
                let attributes = {};
                source.forEach(element => {
                    let fieldsList = element.fieldsList;
                    for (let index = 0, len = fieldsList.length; index < len; index++) {
                        const element = fieldsList[index];
                        attributes[element.id] = element.type;
                    }
                });
                return attributes;
            },
            handleModelComplete () {
                this.$refs['customForm0'][0].validate(async (valid) => {
                    if (valid || this.formInfo.formObj.dataBefor) {
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        try {
                            // 流水号保存生成字段渲染
                            let formInfo = this.formInfo.formObj.structure[0];
                            let fData = this.formData[0];
                            if (formInfo.id === '617dfab913d34c1eb631c1f78ac52266') {
                                if (fData.values['16116b851fe347faa7bd92a0ad3747c8-view'] === '未完成' || fData.values['16a2406b05ca4ec7ae5daedb026a72c8-view'] === '未完成' ||
                            fData.values['240d3af1ff4d4f8fb83e2b689ec1870f-view'] === '未完成' || fData.values['38718b8b9a4c44fc9beb694fdcbc4ccb-view'] === '未完成' ||
                            fData.values['ca071348c2b04ed68b8fdfce855173f0-view'] === '未完成' || fData.values['e1d9961e5e0a468ba27640b11ce14014-view'] === '未完成') {
                                    this.$message({message: '存在未完成工作的策划节点', type: 'warning', duration: 1500});
                                    return;
                                }
                            }
                            if (!fData.values.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                                for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                    let field = formInfo.fieldsList[fieldIndex];
                                    if (field.type === 'subform' && fData.values[field.formField] && fData.values[field.formField].length > 0) {
                                        for (var dataIndex = 0; dataIndex < fData.values[field.formField].length; dataIndex++) {
                                            for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                                let subField = field.options.fieldList[subFieldIndex];
                                                if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && subField.options.config.options.length > 0 && !fData.values[field.formField][dataIndex][subField.formField]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, fData.values[field.formField][dataIndex]);
                                                } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                                    let ext2Obj = JSON.parse(subField.options.ext2);
                                                    let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                                    if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                        await this.setSerialNumber(subField.options.config.options[0].value, subField, fData.values[field.formField][dataIndex]);
                                                    }
                                                }
                                            }
                                        }
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                        let ext2Obj = JSON.parse(field.options.ext2);
                                        let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                        if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                            for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                                if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                    await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                                }
                                            }
                                        } else {
                                            if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                            }
                                        }
                                    } else if (field.type === 'text') {
                                        if (field.options.upMoneyField) { // 配置了金额大写
                                            let upMoneyId = field.options.upMoneyField;
                                            let res = this.convertCurrency(fData.values[upMoneyId]);
                                            fData.values[field.id] = res;
                                        }
                                    }
                                }
                            }
                            // 检查数字类型校验
                            let resObj = await this.$refs.fieldValidation.validateNumberRule(formInfo.fieldsList, fData.values);
                            if (resObj.isRefuse) {
                                let tempRefName = resObj.tempRefName;
                                let tempRefKey = resObj.tempRefKey;
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    this.$refs[tempRefName][0].fieldFocus(tempRefKey);
                                }
                                this.$message({message: '表单字段校验失败!' + resObj.refuseInfo, type: 'warning', duration: 3000});
                                return;
                            }
                            await this.dealSelRuleSetting(formInfo.fieldsList, fData.values);
                            setTimeout(() => {
                                this.$emit('modelComplete', {
                                    forms: this.formData,
                                    modelId: formInfo.modelId
                                });
                            }, 300);
                        } catch (error) {
                            console.error('保存表单数据异常：', error);
                        } finally {
                            loading.close();
                        }
                    } else {
                        let formInfo = this.formInfo.formObj.structure[0];
                        let fData = this.formData[0];
                        let values = fData.values;
                        if (!fData.values.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                            for (let fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                let field = formInfo.fieldsList[fieldIndex];
                                if (field.options.required && (field.type === 'file' || field.type === 'category' || field.type === 'link' || field.type === 'subform')) {
                                    if (values[field.id] === '') {
                                        this.$message.error(field.name + '不能为空');
                                        return;
                                    }
                                }
                            }
                        } else {
                            for (let fieldIndex = 0; fieldIndex < this.formInfo.formObj.structure[0].fieldsList.length; fieldIndex++) {
                                let field = this.formInfo.formObj.structure[0].fieldsList[fieldIndex];
                                if (field.options.required && (field.type === 'file' || field.type === 'category' || field.type === 'link' || field.type === 'subform')) {
                                    if (!values[field.id] || values[field.id] === '') {
                                        this.$message.error(field.name + '不能为空');
                                        return;
                                    }
                                }
                            }
                        }
                        return false;
                    }
                });
            },
            convertCurrency (money) {
                // 汉字的数字
                // eslint-disable-next-line no-array-constructor
                var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
                // 基本单位
                // eslint-disable-next-line no-array-constructor
                var cnIntRadice = new Array('', '拾', '佰', '仟');
                // 对应整数部分扩展单位
                // eslint-disable-next-line no-array-constructor
                var cnIntUnits = new Array('', '万', '亿', '兆');
                // 对应小数部分单位
                // eslint-disable-next-line no-array-constructor
                var cnDecUnits = new Array('角', '分', '毫', '厘');
                // 整数金额时后面跟的字符
                var cnInteger = '整';
                // 整型完以后的单位
                var cnIntLast = '元';
                // 最大处理的数字
                var maxNum = 999999999999999.9999;
                // 金额整数部分
                var integerNum;
                // 金额小数部分
                var decimalNum;
                // 输出的中文金额字符串
                var chineseStr = '';
                // 分离金额后用的数组，预定义
                var parts;
                if (money == '') { return ''; }
                money = parseFloat(money);
                if (money >= maxNum) {
                // 超出最大处理数字
                    return '';
                }
                if (money == 0) {
                    chineseStr = cnNums[0] + cnIntLast + cnInteger;
                    return chineseStr;
                }
                // 转换为字符串
                money = money.toString();
                if (money.indexOf('.') == -1) {
                    integerNum = money;
                    decimalNum = '';
                } else {
                    parts = money.split('.');
                    integerNum = parts[0];
                    decimalNum = parts[1].substr(0, 4);
                }
                // 获取整型部分转换
                if (parseInt(integerNum, 10) > 0) {
                    var zeroCount = 0;
                    var IntLen = integerNum.length;
                    for (var i = 0; i < IntLen; i++) {
                        var n = integerNum.substr(i, 1);
                        var p = IntLen - i - 1;
                        var q = p / 4;
                        var m = p % 4;
                        if (n == '0') {
                            zeroCount++;
                        } else {
                            if (zeroCount > 0) {
                                chineseStr += cnNums[0];
                            }
                            // 归零
                            zeroCount = 0;
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                        }
                        if (m == 0 && zeroCount < 4) {
                            chineseStr += cnIntUnits[q];
                        }
                    }
                    chineseStr += cnIntLast;
                }
                // 小数部分
                if (decimalNum != '') {
                    var decLen = decimalNum.length;
                    for (var i = 0; i < decLen; i++) {
                        var n = decimalNum.substr(i, 1);
                        if (n != '0') {
                            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                        }
                    }
                }
                if (chineseStr == '') {
                    chineseStr += cnNums[0] + cnIntLast + cnInteger;
                } else if (decimalNum == '') {
                    chineseStr += cnInteger;
                }
                return chineseStr;
            },
            async cancelClick () {
                this.$emit('cancelClick');
            },
            async setSerialNumber (sid, field, formData) {
                if (sid) {
                    let numberObj = await getSerialNumber(sid);
                    if (numberObj) {
                        formData[field.formField] = numberObj.newSerialNumber;
                        formData[field.formField + '-sn'] = numberObj.sn;
                    }
                }
            },
            handleView () {
                this.$emit('handleView', this.currentRowData);
            },
            exportExcelData () {
                this.$emit('exportExcelData', this.currentRowData);
            },
            handleModelFormDelete () {
                this.$emit('handleModelFormDelete', this.currentRowData);
            },
            _getModelFormData () {
                let temporaryModelFormData;
                // console.log(this.formInfo.formObj);
                if (this.formInfo.formObj && this.formInfo.formObj.instance) {
                    try {
                        let strTemporaryData = this.formInfo.formObj.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryModelFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析模型表单数据异常：', error);
                    }
                }
                return temporaryModelFormData;
            },
            async _initPopData () { // 主子表新增时弹出级联显示逻辑
                for (let idx = 0; idx < this.forms.length; idx++) {
                    let element = this.forms[idx];
                    let fieldsList = element.fieldsList;
                    let values = {};
                    let attributes = {};

                    let linkFieldIdList = [];
                    for (let index = 0, len = fieldsList.length; index < len; index++) {
                        let ele = clone(fieldsList[index]);
                        values[ele.id] = '';
                        attributes[ele.id] = ele.type;
                        // 将主表单带过来的关联字段值赋值
                        // console.log(this.currentRowData);
                        if (this.currentRowData) {
                            if (ele.type === 'link') {
                                if (!isEmpty(this.currentRowData[ele.id + '-link'])) {
                                    linkFieldIdList.push(ele.id);
                                    values[ele.id] = this.currentRowData[ele.id];
                                    values[ele.id + '-link'] = this.currentRowData[ele.id + '-link'];
                                    values[ele.id + '-view'] = this.currentRowData[ele.id + '-view'];
                                }
                            }
                        }
                        // 处理权限字段
                        let ext2 = ele.options.ext2;
                        if (ext2) {
                            let curObj = JSON.parse(ext2);
                            ele.formFieldAuth = curObj.formFieldAuth;
                            ele.approveFieldAuth = curObj.approveFieldAuth;
                        }
                    }

                    this.collapseActiveName = element.id;
                    this.formData.push({
                        formId: element.id,
                        values: values,
                        attributes: attributes,
                        colSpan: element.colSpan ? element.colSpan : 1,
                        ext1: element.ext1 ? Number(element.ext1) : 0
                    });
                    this.$emit('setIsShowForm', true);
                    // 处理关联字段的关联映射显示
                    if (linkFieldIdList.length > 0) {
                        for (let k = 0; k < linkFieldIdList.length; k++) {
                            let linkFieldId = linkFieldIdList[k];
                            let linkDataId = this.formData[0].values[linkFieldId + '-link'];
                            if (linkDataId) {
                                let linkDataInfo = await getModelFormInstanceById(linkDataId);
                                if (linkDataInfo) {
                                    let allFormFieldList = linkDataInfo.formObj.structure[0].fieldsList;
                                    let linkDataValue = JSON.parse(linkDataInfo.formObj.instance);
                                    let sourceData = linkDataValue.values;
                                    await this.asynMainFormData(sourceData, allFormFieldList, linkFieldId, 0);
                                }
                            }
                        }
                    }
                }
            },
            switchAddFormData () {
                this.$emit('switchMode', 1);
            },
            dataExport () {
                let url = `${API_EXPORT_MODEL_TITLE_FORM_EXCEL}`;
                url = url.replace(':modelId', this.formInfo.formObj.structure[0].modelId);
                this.download(url);
            },
            download (url) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            handleNavPage () { // 审批流发起或保存成功返回处理逻辑
                if (this.isReturnToNav) { // 返回客户端方的方法进行页面跳转或逻辑操作
                    this.isShowApprovalTemplatePop = false;
                    this.$emit('handleNavPage');
                } else {
                    let currentUserStr = sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    if (currentUserInfo.switchLayoutFlg === 2) {
                        this.navMyApprovalApplied();
                    } else {
                        this.navMyApproval();
                    }
                }
            },
            loadLinkData (data, targetField) {
                let formInfo = this.formInfo.formObj.structure[0];
                if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                    for (var i = 0; i < formInfo.fieldsList.length; i++) {
                        let tempField = formInfo.fieldsList[i];
                        if (targetField.id === tempField.id) {
                            this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                        }
                    }
                }
            },
            refreshViewField () {
                this.loadTimerField = new Date().getTime();
            },
            async handelShowDiagram () { // 显示流程图
                await this.setProcessViewInfo(this.processInstanceId);
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.diagrams.setProcessState(false);
                    this.$refs.diagrams.resetDiagramUrl();
                }, 0);
            },
            async setProcessViewInfo (businessInstanceId) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instances = await getProcessInstancesDetail(businessInstanceId);
                let tasks = await getAllUserTask(this.instances.id, this.instances.processServiceId, null, this.instances.deploymentId);
                this.taskList = tasks;
                let treeList = [];
                if (this.instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                loading.close();
            },
            handleSelectFromHis (index, form) {
                this.loadTimer = new Date().getTime();
                this.formIndex = index;
                this.currentModelId = form.modelId;
                this.isShowDataCopyDialog = true;
            },
            reSetProcessFormData (data) { // 选择好复制的数据后，重置流程表单数据
                let selectValues = clone(data);
                if (selectValues.hasOwnProperty('id')) {
                    delete selectValues.id;
                }
                this.formData[this.formIndex].values = selectValues;
                this.refreshViewField();
                this.isShowDataCopyDialog = false;
            },
            async showQR (obj) {
                let instance = JSON.parse(this.formInfo.formObj.instance);
                // let domain = document.domain;
                let qrPre = '/download/image?filePath=';
                // if (domain.indexOf('bcbpm.com') !== -1) {
                //     qrPre = '/bcbpm' + qrPre;
                // }
                let env = process.env.NODE_ENV;
                if (env === 'production') {
                    qrPre = '/bcbpm' + qrPre;
                }
                this.imageKey = new Date().getTime();
                if (instance.qrpath) {
                    this.qrUrl = qrPre + instance.qrpath;
                } else {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let param = {id: this.id, formName: obj.formName, modelId: obj.modelId};
                    let res = await getModelFormInstanceQR(param);
                    this.qrUrl = qrPre + res.filePath;
                    this.qrTit = '二维码';
                    loading.close();
                }
            },
            handleSubFormView (index) {
                let subFormViewMode = this.formData[index].values['subFormViewMode'];
                if (!subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                    subFormViewMode = 1;
                } else {
                    subFormViewMode = 0;
                }
                // console.log(subFormViewMode);
                this.formData[index].values['subFormViewMode'] = subFormViewMode;
                this.refreshViewField();
            },
            getSubformName (formData, field) {
            // formData[field.id + '-view'];
                // console.log(formData);
                // console.log(field);
                // console.log(formData[field.id]);
                if (Array.isArray(formData[field.id])) {
                    return field.name + '(' + formData[field.id].length + ')';
                } else {
                    return field.name + '(0)';
                }
            },
            isShowNormalField (field, index, formData) {
                let subFormViewMode = formData.values['subFormViewMode'];
                if (subFormViewMode !== 0 && (formData.ext1 === 1 || subFormViewMode === 1)) { // 子表单页签模式
                    if (field.type === 'subform') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (formData.ext1 === 0 || !subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                    return true;
                }
            },
            async getModelListByMainFormId () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                // console.log(this.formInfo);
                let modelList = await getModelListByMainFormId(this.formInfo.formId);
                this.relateModelList = modelList;
                // console.log(modelList);
                if (this.relateModelList && this.relateModelList.length > 0) {
                    // 默认打开第一个关联表单数据
                    this.relateFormTabName = this.relateModelList[0].id;
                    this.renderModelFormList(this.relateModelList[0]);
                }
                loading.close();
            },
            async renderModelFormList (model) {
                // 主表的formid
                model.mainFormId = this.formInfo.formId;
                // 主表当前数据id
                model.mainFormDataId = this.id;
                this.loadTimerRelate = new Date().getTime();
                // console.log(model);
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs['relateModelList' + model.id]) {
                        this.$refs['relateModelList' + model.id][0].renderFormList(model);
                    }
                }, 0);
            },
            handleRelateFormTabClick (tab, event) {
                // console.log(tab.name);
                this.relateFormTabName = tab.name;
                for (var i = 0; i < this.relateModelList.length; i++) {
                    let model = this.relateModelList[i];
                    // console.log(model.id);
                    if (model.id === this.relateFormTabName) {
                        this.renderModelFormList(model);
                    }
                }
            },
            async asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.forms[0].fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData);
                                    }
                                }
                            }
                        });
                    });
                    selectTableColumns.forEach(fieldObj => {
                        if (fieldObj.type === 'subform') {
                            // console.log(fieldObj);
                            // console.log(currentlinkFieldId);// 当前表单的关联字段id
                            targetFormFieldlist.forEach(element => {
                                // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                                if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                    if (element.options.dataSourceSubFieldId) {
                                        if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                            if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                                for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                    let tempField = this.forms[index].fieldsList[i];
                                                    if (element.id === tempField.id) {
                                                        this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                    }
                                                }
                                            }
                                            // this.reSetSelectOptions(element, fieldObj, sourceData);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            },
            // 修改配置了关联映射的字段值
            updSynLinkFieldData (element, fieldObj, sourceData) {
                let type = fieldObj.type;
                let sourceValueKey = ''; // 对应userId等唯一性值
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let can = false; // 是否支持级联显示
                let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    sourceDepartmentValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-tree'];
                } else if (type === 'user') {
                    // -user
                    can = true;
                    sourceValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-user'];
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                } else if (type === 'link') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'subform') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                }
                if (can) {
                    if (element.type === 'text') {
                        this.formData[0].values[element.id] = sourceValue;
                        this.formData[0].values[element.id + '-view'] = '';
                    } else if (element.type === 'number' || element.type === 'calculation') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[0].values[element.id] = sourceValue;
                            this.formData[0].values[element.id + '-view'] = '';
                        } else {
                            this.formData[0].values[element.id] = '';
                            this.formData[0].values[element.id + '-view'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'user') {
                        // console.log(element);
                        // fieldId-user: trueName ，fieldId: userId
                        // console.log(sourceValue);
                        // console.log(sourceValueKey);
                        if (!isEmpty(sourceValue)) {
                            this.formData[0].values[element.id] = sourceValueKey;
                            this.formData[0].values[element.id + '-user'] = sourceValue;
                        } else {
                            this.formData[0].values[element.id] = '';
                            this.formData[0].values[element.id + '-user'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'department') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[0].values[element.id] = sourceDepartmentValueKey;
                            this.formData[0].values[element.id + '-tree'] = sourceValue;
                        } else {
                            this.formData[0].values[element.id] = '';
                            this.formData[0].values[element.id + '-tree'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            let targetFieldOptions = element.options.config.options;
                            for (let i = 0; i < targetFieldOptions.length; i++) {
                                let optionItem = targetFieldOptions[i];
                                if (optionItem.title === sourceValue) {
                                    targetFieldValue = optionItem;
                                    break;
                                }
                            }
                            if (targetFieldValue) {
                                this.formData[0].values[element.id] = targetFieldValue.value;
                                this.formData[0].values[element.id + '-view'] = targetFieldValue.title;
                            }
                        } else {
                            this.formData[0].values[element.id] = '';
                            this.formData[0].values[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            this.formData[0].values[element.id] = newValue;
                        } else {
                            this.formData[0].values[element.id] = '';
                        }
                    }
                }
            },
            async dealSelRuleSetting (fieldsList, formValues) { // 根据表单数据规则设置设置下拉或选项类型字段的选中值
                let fieldsMap = new Map();
                let fieldRuleMap = new Map();// 字段规则map
                let fieldSelKVMap = new Map();
                if (fieldsList && Array.isArray(fieldsList)) {
                    for (var index = 0; index < fieldsList.length; index++) {
                        let field = fieldsList[index];
                        fieldsMap.set(field.id, field);
                        if (field.type === 'select' || (field.type === 'category' && field.options.config.type === 'single')) {
                            for (let k = 0; k < field.options.config.options.length; k++) {
                                let item = field.options.config.options[k];
                                if (isEmpty(item.assignmentFieldId) && !isEmpty(item.assignmentFieldValue)) { // key为空，值不为空
                                    fieldRuleMap.set(item.value, item.assignmentFieldValue);
                                    fieldSelKVMap.set(item.value, field.id);
                                }
                            }
                        }
                    }
                }
                if (fieldRuleMap.size > 0) {
                    // console.log(fieldRuleMap);
                    // console.log(fieldSelKVMap);
                    let tansgerFieldRuleMap = new Map();// 字段规则map
                    for (let fieldIndex = 0; fieldIndex < fieldsList.length; fieldIndex++) {
                        let field = fieldsList[fieldIndex];
                        fieldRuleMap.forEach(function (value, key) {
                            if (value && value.indexOf(field.name) !== -1) {
                                let tempVal = '';
                                if (tansgerFieldRuleMap.has(key)) {
                                    tempVal = tansgerFieldRuleMap.get(key);
                                    tempVal = tempVal.replace(field.name, field.id);
                                } else {
                                    tempVal = value.replace(field.name, field.id);
                                }
                                tansgerFieldRuleMap.set(key, tempVal);
                            }
                        });
                    }
                    // console.log(tansgerFieldRuleMap);
                    let finalArr = [];
                    tansgerFieldRuleMap.forEach(function (value, key) {
                        finalArr.push({key: key, value: value});
                    });
                    // console.log(finalArr);
                    for (let i = 0; i < finalArr.length; i++) {
                        let obj = finalArr[i];
                        let result = await this.$refs.fieldValidation.chkPassRule(null, obj.value.trim(), formValues, fieldsMap, null);
                        // console.log(result);
                        if (result) {
                            formValues[fieldSelKVMap.get(obj.key)] = obj.key;
                        }
                    }
                    // console.log(formValues);
                }
            }
        }
    };
</script>

<style lang="less">
    .busi-modelDetail-pop {
        width: 100%;
        height: 100%;
        margin-top: -3%;
        .dialog{
            .el-dialog__body{
                padding: 0px;
                height: ~"calc(100% - 10px)";
                // height: 100%;
            }
        }
        .model-top{
            background: #fff;
            width: 100%;
            height: 10vh;
            line-height: 10vh;
            display: flex;
            align-items: center;
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
                height: 8vh;
                line-height: 8vh;
            }
            .tit{
                display: flex;
                width: 30vw;
                justify-content: start;
                align-items: center;
                padding-left: 20px;
                height: 100%;
                // margin-top: 2.5vh;
            }
            .btns{
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: end;
                padding-right: 60px;
                margin-top: 2.5vh;
                height: 100%;
                div{
                    display: flex;
                }
            }
        }
        .el-collapse-item__wrap {
            padding: 0 20px;
            height: ~"calc(100% - 6vh)";
            overflow: auto;
            padding-bottom: 2vh;
        }

        .el-collapse {
            width: 100%;
            .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
              margin-bottom:5px
            }
        }

        .el-form {
            width: 100%;
            .el-cascader--small,.el-select--small{
                width: 100%;
            }
            .render-form-item{
                .el-row{
                    display: flex;
                    .subform-field-item{
                        width: 100%;
                    }
                }
            }
        }

        .el-collapse-title {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            & > .el-button {
                margin-right: 10px;
            }
            .btns{
                height: 6vh;
                line-height: 6vh;
            }
        }

        .model-btns {
            height: 80px;
            padding: 0 10px 0 0;
        }

        .model-top {
            margin-left: 15px;
            margin-right: 15px;
            height: 8vh;
            line-height: 8vh;
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
                line-height: 6vh;
            }
            .el-card__body {
                padding:8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }

        .model-content {
            flex: 1;
            margin-top: 6px;
            width: 100%;
            display: flex;
            flex-direction: row;
            overflow: auto;
            .content-left{
                flex: 1;
                overflow: auto;
                overflow: auto;
                background: #fff;
            }
            .content-right{
                width: 22vw;
                background: #fff;
                margin-left: 4px;
                padding-left: 20px;
                display: flex;
                flex-direction: column;
                .content-right-tit{
                    display: flex;
                    border-bottom: 1px solid #e2e0e0;
                    height: 60px;
                    line-height: 60px;
                    justify-content: center;
                    align-items: center;
                    .tit-approve,.tit-uprecord{
                        font-size: 20px;
                        flex: 1;
                        cursor: pointer;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
                    .tit-uprecord{
                    margin-right: 40px;
                    }
                    .activeTit{
                        color: #AB271A;
                        .line{
                            width: 30px;
                            border: 2px solid #AB271A;
                            border-radius: 2px;
                        }
                    }
                }
                .content-right-content{
                    flex: 1;
                    .content-approve{
                        display: flex;
                        position: relative;
                        height: 100%;
                        flex-direction: column;
                        .approve-title{
                            font-size: 20px;
                            font-weight: 700;
                            margin-top: 10px;
                            color: #333;
                            max-height: 300px;
                            height: auto;
                            cursor: pointer;
                        }
                        .approve-info{
                            flex: 1;
                            margin-top: 10px;
                        }
                    }
                    .content-uprecord{
                        position: relative;
                        height: 100%;
                        flex-direction: column;
                        .uprecord-item{
                            // margin-top: 20px;
                            background: #fff;
                            font-size: 16px;
                            display: flex;
                            .left{
                                width: 30px;
                                display: flex;
                                margin-top: 20px;
                                position: relative;
                                left: -8px;
                                padding-top: 8px;
                                .dot{
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 12px;
                                    background: rgb(187, 188, 190);
                                    position: relative;
                                    left: 6px;
                                }
                                .line{
                                    flex: 1;
                                    border-left: 1px solid  rgb(187, 188, 190);
                                    height: ~"calc(100% + 30px)";
                                    // height: 100%;
                                }
                            }
                            .right{
                                flex: 1;
                                .item-bottom{
                                    .top{
                                        height: 20px;
                                        background: #fff;
                                    }
                                    .bottom{
                                        line-height: 26px;
                                        font-weight: 600;
                                        margin-top: 10px;
                                        background: rgb(249, 249, 249);
                                        padding: 10px;
                                        border-radius: 4px;
                                        .item-top{
                                            display: flex;
                                            .upUser{
                                                font-weight: 700;
                                                flex: 1;
                                            }
                                            .upTime{
                                                flex: 1;
                                                text-align: right;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }
        .comments {
            width: 300px;
        }
        .collapseItem{
           width: 100%;
           height: 100%;
           overflow: hidden;
        }
    }
    .el-popover {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/RelateModelDetail.vue